import { render, staticRenderFns } from "./CredorCampanha.vue?vue&type=template&id=dd35a566"
import script from "./CredorCampanha.vue?vue&type=script&lang=js"
export * from "./CredorCampanha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports